<template>

    <div class="container">

        <app-head title="Customer Groups" />

        <div class="d-flex justify-content-start align-items-center mb-3 gap-3">
            <h1 class="">{{ __('Customer Groups') }}</h1>
            <div class="">
                <inertia-link class="btn btn-primary" :href="route('admin.customer-groups.create')">
                    {{ __('Create') }}
                </inertia-link>
            </div>
        </div>

        <div class="d-flex mb-3">
            <search-filter v-model="form.search" class="" @reset="reset">
            </search-filter>
        </div>

        <div class="d-flex justify-content-between">
            <results :meta="customerGroups.meta" />
        </div>

        <div class="card">
            <data-table :items="customerGroups.data"
                        :links="customerGroups.meta.links"
                        :columns="columns"
                        >
                <data-table-row v-for="customerGroup in customerGroups.data" :key="customerGroup.id">
                    <td>
                        {{ customerGroup.id }}
                    </td>
                    <td>
                        <inertia-link class="" :href="route('admin.customer-groups.edit', customerGroup)">
                            {{ customerGroup.name }}
                        </inertia-link>
                    </td>
                    <td>
                        <inertia-link class="" :href="route('admin.customers.index', {customer_group_id: customerGroup.id})">
                            {{ customerGroup.customers_count || 0 | localizeNumber }}
                        </inertia-link>
                    </td>
                    <td class="text-end">
                        <i class="bi bi-chevron-right"></i>
                    </td>
                </data-table-row>
            </data-table>
        </div>

    </div>

</template>

<script>

    import DataTable from '@/shared/Admin/DataTable';
    import DataTableRow from '@/shared/Admin/DataTableRow';
    import SearchFilter from '@/shared/Admin/SearchFilter';
    import SelectInput from '@/shared/Inputs/SelectInput';
    import Results from '@/shared/Admin/Results';


    export default {
        props: {
            filters: Object,
            customerGroups: Object,
        },
        components: {
            DataTable,
            DataTableRow,
            SearchFilter,
            SelectInput,
            Results,
        },
        data() {
            return {
                form: {
                    search: this.filters.search,
                },
                columns: {
                    id: {label: 'ID', sortable: 'id'},
                    name: {label: 'Name', sortable: 'name'},
                    number_customers: {label: 'Customers'},
                },
            }
        },
        watch: {
            form: {
                deep: true,
                handler: _.debounce(function () {
                    this.$inertia.get(this.route('admin.customer-groups.index'), this.form, {preserveState: true})
                }, 300, {trailing: true}),
            },
        },
        methods: {
            reset() {
                this.form = _.mapValues(this.form, () => null)
            },
        },
    }
</script>